"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgUmbrella = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M35.995 23.905A1 1 0 0135 25H13a1 1 0 01-.995-1.095 12.05 12.05 0 0123.99 0zM24 15c-4.807 0-8.883 3.39-9.84 8h19.68c-.957-4.61-5.033-8-9.84-8zm1 11.703V31a2 2 0 003.972.337L25 26.703zM31 31a4 4 0 11-8 0v-7c0-.928 1.155-1.356 1.76-.65l6 7A1 1 0 0131 31z",
    id: "umbrella_svg__a"
  }));
};

var _default = SvgUmbrella;
exports.default = _default;